// extracted by mini-css-extract-plugin
module.exports = {"tools":"BankDetailsPage_tools__2wo_l","mobileTools":"BankDetailsPage_mobileTools__1v8kc","page":"BankDetailsPage_page__9q7D7","right":"BankDetailsPage_right__502zM"};